module.exports = __webpack_public_path__ + "static/img/auto_declare_1.078e633.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/auto_declare_1.png
// module id = GdqR
// module chunks = 34